module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('p', [_vm._v("Connexion en cours...")]), _vm._v(" "), _c('p', [_vm._v("Merci de patienter")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54499458","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Sso.vue
// module id = 763
// module chunks = 0